<template>
  <div id="damagesview">
        <damages v-bind:damages="damages"></damages>
        <create-damage v-on:create-damage="createDamage"></create-damage>
  </div>
</template>

<script>
import sweetalert from 'sweetalert';
import Damages from '@/components/Damages/Damages';
import CreateDamage from '@/components/Damages/CreateDamage';
export default {
  	name: 'Damagesview',
  	props: ['car'],
	components: {
	    Damages,
	    CreateDamage,
	},
  	data() {
	    return {
	      		damages: []
			  }
	},
	sockets: {
	    syncDamages( obj ) {
		    console.log( obj.damages );
		    if(obj.action == 'getAll') { console.log('getAll sync');	this.damages = obj.damages; }
		    if(obj.action == 'created') { console.log('created sync');	this.damages.push( obj.damages[0] ); }
    	},
    },  
	methods: {
	    createDamage(newDamage) {
 		   //console.log(newNote); 		    
	      //this.notes.push(newNote);
	      this.$socket.emit('syncDamages', { action: "create",  data: { vgn: this.car.vorgangsnummer, damage: newDamage.damage } } );
	      //console.log(this.notes);
	      }
	},
	
	mounted: function(){
		//console.log('mounted')
		//console.log( this.car.vorgangsnummer );

		if(this.car.readby < 1) {		
			this.car.readby = 1;
			this.$socket.emit('updateCarR', { car: this.car, quiet: 1 } );
		}

		this.$socket.emit('syncDamages', {  action: "getAll", data: { vgn: this.car.vorgangsnummer } } );
	}
	
  
};
</script>